import React from "react";
import { Link } from "react-router-dom";
import useWindowDimensions from "../../../../misc/windowDimensions";

export default function Videos({gallery}) {
  const { height, width } = useWindowDimensions()
  return (
    <div
      style={{
        // height: "70px",
        padding: "0px 0px",
        backgroundColor: "white",
      }}
    >
      <div className="container">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "60px",
            paddingBottom: "40px",
          }}
        >
          <p style={{ margin: 0, fontWeight: 700 }} className="h6-nunito">
            Kumpulan Video (Galeri)
          </p>
          <div>
            <Link
              // onClick={() => console.log("PENCET1")}
              style={{
                backgroundColor: "#1672BD",
                color: "white",
                border: "1px solid #1672BD",
              }}
              className="nav-link btn p-nunito btn-instance"
              to="/event/gallery"
            >
              Nonton Semua
            </Link>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          {gallery.filter((item,idx) => {
            return width < 1024 ? idx < 2 : idx < 3}).map((item) => (
            <div className="col-lg-4 col-md-6 col-12" key={item._id} style={{padding: '10px'}}>
              <iframe
                width="100%"
                height="250"
                style={{borderRadius: '5px'}}
                src={item.url}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={item.title}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
